<div *ngIf="stepDetails == 'create'"
  class="flex items-center justify-between bg-blue-600 text-white rounded-t px-6 py-4">
  <h5 class="text-lg font-semibold mb-0">{{title}}</h5>
  <div class="flex gap-2">
    <button *ngIf="ocFrom.valid && areBothFilesUploaded" type="button"
      class="bg-green-600 hover:bg-green-700 text-white font-medium rounded px-4 py-2 transition"
      (click)="showConform()">Submit</button>
  </div>
</div>
<div class="bg-amber-50 overflow-hidden transition-all "
  [ngClass]="{'border-2 border-gray-300 duration-200 hover:shadow-md': !stepDetails}">

  <form [formGroup]="ocFrom" class="proposal-form-container px-6 py-4" *ngIf="stepDetails == 'create'">
    <div class="bg-amber-50 border-2 border-gray-300 mb-6 rounded transition-all duration-200 hover:shadow-md">
      <!-- INSERT_YOUR_CODE -->

      <div
        class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
        <h3 class="text-lg font-semibold flex items-center">
          <span class="w-8 h-8 rounded-lg bg-blue-100 text-blue-600 flex items-center justify-center mr-3 text-sm"><i
              class="pi pi-building"></i></span>
          {{ title }}
        </h3>



      </div>
      <div class="p-6 border-t border-slate-100 animate-fade-in">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
          <div class="flex flex-col">
            <label for="name" class="block font-medium text-slate-700 mb-2">
              Open Challenge Version
              <ng-container
                *ngIf="ocFrom.get('name')?.errors?.['required'] || ocFrom.get('name')?.hasValidator(requiredValidator)">
                <span class="text-red-500">*</span>
              </ng-container>
            </label>
            <input pInputText id="name" formControlName="name" autocomplete="off"
              class="w-full px-2.5 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
          </div>
          <div class="flex flex-col">
            <label for="nodal_directorates" class="block font-medium text-slate-700 mb-2">
              Send to (directorates)
              <ng-container
                *ngIf="ocFrom.get('nodal_directorates')?.errors?.['required'] || ocFrom.get('nodal_directorates')?.hasValidator(requiredValidator)">
                <span class="text-red-500">*</span>
              </ng-container>
            </label>
            <p-multiSelect [options]="nodalDirectorates" chip="true" numberDisplay="3" optionLabel="name"
              optionValue="id" filter="true" filterBy="name" formControlName="nodal_directorates"
              placeholder="Select Nodal Directorate(s)" appendTo="body" class="w-full"></p-multiSelect>
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6 mb-4">
          <div class="flex flex-col">
            <label for="start_date" class="block font-medium text-slate-700 mb-2">
              Window Opening Date
              <ng-container
                *ngIf="ocFrom.get('start_date')?.errors?.['required'] || ocFrom.get('start_date')?.hasValidator(requiredValidator)">
                <span class="text-red-500">*</span>
              </ng-container>
            </label>
            <input pInputText id="start_date" type="date" formControlName="start_date"
              class="w-full px-2.5  py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
          </div>
          <div class="flex flex-col">
            <label for="end_date" class="block font-medium text-slate-700 mb-2">
              Window Closing Date
              <ng-container
                *ngIf="ocFrom.get('end_date')?.errors?.['required'] || ocFrom.get('end_date')?.hasValidator(requiredValidator)">
                <span class="text-red-500">*</span>
              </ng-container>
            </label>
            <input pInputText id="end_date" type="date" formControlName="end_date"
              class="w-full px-2.5 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
          </div>
        </div>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-4">
          <div class="flex flex-col">
            <label for="agencie_1" class="block font-medium text-slate-700 mb-2">
              Partner Incubator 1
              <ng-container
                *ngIf="ocFrom.get('agencie_1')?.errors?.['required'] || ocFrom.get('agencie_1')?.hasValidator(requiredValidator)">
                <span class="text-red-500">*</span>
              </ng-container>
            </label>
            <input pInputText id="agencie_1" formControlName="agencie_1" autocomplete="off"
              class="w-full px-2.5 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
          </div>
          <div class="flex flex-col">
            <label for="agencie_2" class="block font-medium text-slate-700 mb-2">
              Partner Incubator 2
              <ng-container
                *ngIf="ocFrom.get('agencie_2')?.errors?.['required'] || ocFrom.get('agencie_2')?.hasValidator(requiredValidator)">
                <span class="text-red-500">*</span>
              </ng-container>
            </label>
            <input pInputText id="agencie_2" formControlName="agencie_2" autocomplete="off"
              class="w-full px-2.5 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
          </div>
          <div class="flex flex-col">
            <label for="agencie_3" class="block font-medium text-slate-700 mb-2">
              Partner Incubator 3
              <ng-container
                *ngIf="ocFrom.get('agencie_3')?.errors?.['required'] || ocFrom.get('agencie_3')?.hasValidator(requiredValidator)">
                <span class="text-red-500">*</span>
              </ng-container>
            </label>
            <input pInputText id="agencie_3" formControlName="agencie_3" autocomplete="off"
              class="w-full px-2.5 py-2.5 border-2 border-slate-500 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all" />
          </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div class="flex flex-col">
            <label for="fileUpload1" class="flex items-center gap-3 font-medium text-slate-700 mb-2">
              <span>Choose (.csv) File <span class="text-red-500">*</span></span>
              <a [href]="baseUrl + '/media/sample_csv/applicant_response.csv'" download="applicant_response.csv"
                class="inline-flex items-center gap-1.5 px-3 py-1 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-xs font-medium rounded shadow hover:shadow-md hover:from-blue-700 hover:to-blue-800 transition-all duration-200">
                <i class="pi pi-download text-xs"></i>
                <span>Download Sample CSV</span>
              </a>
            </label>
            <input type="file" id="fileUpload1" accept=".csv,.xlsx"
              class="border-2 border-slate-300 px-2.5 py-2.5 w-full" (change)="handleFileInput($event, 'file1')" />
          </div>
          <div class="flex flex-col">
            <label for="fileUpload2" class="block font-medium text-slate-700 mb-2">
              Choose Briefcase Folder (.zip) <span class="text-red-500">*</span>
            </label>
            <input type="file" id="fileUpload2" accept=".zip" class="border-2 border-slate-300 px-2.5 py-2.5 w-full"
              (change)="handleFileInput($event, 'file2')" />
          </div>
        </div>
        <!-- 
        <div class="mb-4 flex items-center">
          <label for="nodal_directorates" class="block font-medium text-slate-700 mb-2 w-1/3">
            Category
            <ng-container *ngIf="ocFrom.get('category')?.errors?.['required'] || ocFrom.get('category')?.hasValidator(requiredValidator)">
              <span class="text-red-500">*</span>
            </ng-container>
          </label>
          <div class="w-2/3">
            <p-dropdown [options]="categoryOptions" optionLabel="label" optionValue="value" formControlName="category" placeholder="Select Category" appendTo="body" class="w-100"
            styleClass="w-full [&_.p-dropdown]:w-full [&_.p-dropdown]:border-slate-300 [&_.p-dropdown]:rounded"></p-dropdown>
          </div>
        </div>
        -->
        <!-- 
        <div class="mb-4">
          <p class="block bg-blue-500 text-white font-medium p-2">
            Description
            <ng-container *ngIf="ocFrom.get('description')?.errors?.['required'] || ocFrom.get('description')?.hasValidator(requiredValidator)">
              <span class="text-yellow-500">*</span>
            </ng-container>
          </p>
          <editor [init]="init" formControlName="description"></editor>
        </div>
        -->
      </div>
    </div>
  </form>

  <!-- Guidelines Section -->
  <div *ngIf="stepDetails == 'create'" class="px-6 pb-4">
    <div class="bg-blue-50 border-l-4 border-blue-500 rounded-r-lg p-4 shadow-sm mb-4">
      <div class="flex items-start">
        <div class="flex-shrink-0">
          <i class="pi pi-info-circle text-blue-600 text-xl"></i>
        </div>
        <div class="ml-3 flex-1">
          <h4 class="text-sm font-semibold text-blue-900 mb-2">Guidelines for File Upload</h4>
          <ul class="text-sm text-blue-800 space-y-1.5 list-disc list-inside">
            <li>The challenge number in the CSV file should match the folder number in the briefcase zipped folder to
              link the files with particular challenge.</li>
            <li><strong>Challenge No</strong> and <strong>Innovation Title</strong> are mandatory fields in the CSV
              file.</li>
          </ul>
        </div>
      </div>
    </div>

    <!-- Sample CSV Table -->
    <div class="bg-white border-2 border-gray-300 rounded-lg p-4 mb-4 shadow-sm">
      <h5 class="text-sm font-semibold text-gray-800 mb-3 flex items-center">
        <i class="pi pi-file text-blue-600 mr-2"></i>
        Sample CSV File Structure
      </h5>
      <div class="overflow-x-auto">
        <table class="min-w-full text-xs border-collapse border border-gray-400">
          <thead>
            <tr class="bg-gray-100">
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Ser No.</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Challenge No*</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Applying as</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Thematic OC/Problem
                Statement</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Name of Applicant
              </th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Gender</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Phone Number</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Email</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Address</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">State</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">City</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Company Name</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Designation of
                Applicant</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Company Website</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Portfolio of the
                Company</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Innovation Title*
              </th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Title of Innovative
                Technology</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">Nodal Dte</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">PI 1 Recommendation
              </th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">PI 1 Remarks</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">PI 2 Recommendation
              </th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">PI 2 Remarks</th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">PI 3 Recommendation
              </th>
              <th class="border border-gray-400 px-2 py-1.5 text-left font-semibold text-gray-700">PI 3 Remarks</th>
            </tr>
          </thead>
          <tbody>
            <tr class="bg-white hover:bg-gray-50">
              <td class="border border-gray-400 px-2 py-1.5">1</td>
              <td class="border border-gray-400 px-2 py-1.5 font-medium">54</td>
              <td class="border border-gray-400 px-2 py-1.5">MSME</td>
              <td class="border border-gray-400 px-2 py-1.5">Autonomous system/sub system in surface, aerial and
                sub-surface domains (Indian Navy)</td>
              <td class="border border-gray-400 px-2 py-1.5">Suyash Bafna</td>
              <td class="border border-gray-400 px-2 py-1.5">Male</td>
              <td class="border border-gray-400 px-2 py-1.5">7852348965</td>
              <td class="border border-gray-400 px-2 py-1.5">muskaanuravmalay9&#64;gmail.com</td>
              <td class="border border-gray-400 px-2 py-1.5">JANKI NAGAR R 6437 132/45, SANGAMNER, Maharashtra, India -
                422605</td>
              <td class="border border-gray-400 px-2 py-1.5">Maharashtra</td>
              <td class="border border-gray-400 px-2 py-1.5">Pune</td>
              <td class="border border-gray-400 px-2 py-1.5">Electro Pneumatics and Hydraulics India Pvt Ltd</td>
              <td class="border border-gray-400 px-2 py-1.5">CEO</td>
              <td class="border border-gray-400 px-2 py-1.5">aerospacefield&#64;</td>
              <td class="border border-gray-400 px-2 py-1.5">Unmanned Underwater Vessel platform for multi-disciplinary
                extended range operations</td>
              <td class="border border-gray-400 px-2 py-1.5">Autonomous Naval Surveillance Drone with Underwater
                Detection and Communication Capabilities</td>
              <td class="border border-gray-400 px-2 py-1.5">Marine Sentinel: Autonomous Naval Surveillance and
                Underwater Reconnaissance Drone</td>
              <td class="border border-gray-400 px-2 py-1.5">DNA</td>
              <td class="border border-gray-400 px-2 py-1.5">Not Recommended</td>
              <td class="border border-gray-400 px-2 py-1.5">Startup has good experienced team and strong advisory
                board.</td>
              <td class="border border-gray-400 px-2 py-1.5">Recommended</td>
              <td class="border border-gray-400 px-2 py-1.5">The individual innovator has some innovation ideas that he
                would like to work with IDEX. The financial and operational capabilities are unlikely.</td>
              <td class="border border-gray-400 px-2 py-1.5">Recommended</td>
              <td class="border border-gray-400 px-2 py-1.5">The individual innovator has some innovation ideas that he
                would like to work with IDEX. The financial and operational capabilities are unlikely.</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="text-xs text-gray-600 mt-2 italic">* Mandatory fields</p>
    </div>

    <!-- Briefcase Folder Structure -->
    <div class="bg-white border-2 border-gray-300 rounded-lg p-4 shadow-sm">
      <h5 class="text-sm font-semibold text-gray-800 mb-3 flex items-center">
        <i class="pi pi-folder text-blue-600 mr-2"></i>
        Sample Briefcase Zipped Folder Structure
      </h5>
      <div class="bg-gray-50 border border-gray-300 rounded p-3 font-mono text-xs">
        <div class="text-gray-700 space-y-1">
          <div class="flex items-start">
            <i class="pi pi-folder-open text-blue-600 mr-1 mt-0.5"></i>
            <span class="font-semibold">briefcase_folder.zip</span>
          </div>
          <div class="ml-6 space-y-1">
            <div class="flex items-start">
              <i class="pi pi-folder text-yellow-600 mr-1 mt-0.5"></i>
              <span class="font-semibold text-gray-800">54</span>
              <span class="text-gray-600 ml-2">(Challenge No: 54)</span>
            </div>
            <div class="ml-6 space-y-0.5">
              <div class="flex items-start text-gray-700">
                <i class="pi pi-file text-gray-500 mr-1 mt-0.5"></i>
                <span>proposal_document.pdf</span>
              </div>
              <div class="flex items-start text-gray-700">
                <i class="pi pi-file text-gray-500 mr-1 mt-0.5"></i>
                <span>technical_specification.docx</span>
              </div>
              <div class="flex items-start text-gray-700">
                <i class="pi pi-file text-gray-500 mr-1 mt-0.5"></i>
                <span>company_profile.pdf</span>
              </div>
            </div>
            <div class="flex items-start mt-2">
              <i class="pi pi-folder text-yellow-600 mr-1 mt-0.5"></i>
              <span class="font-semibold text-gray-800">55</span>
              <span class="text-gray-600 ml-2">(Challenge No: 55)</span>
            </div>
            <div class="ml-6 space-y-0.5">
              <div class="flex items-start text-gray-700">
                <i class="pi pi-file text-gray-500 mr-1 mt-0.5"></i>
                <span>innovation_proposal.pdf</span>
              </div>
              <div class="flex items-start text-gray-700">
                <i class="pi pi-file text-gray-500 mr-1 mt-0.5"></i>
                <span>supporting_documents.zip</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="text-xs text-gray-600 mt-3">
        <strong>Note:</strong> The folder number (e.g., "54", "55") inside the zip file must match the <strong>Challenge
          No</strong> in the CSV file for proper linking.
      </p>
    </div>
  </div>

  <div *ngIf="stepDetails == 'screening'">
    <div class="flex flex-col md:flex-row bg-white border border-gray-200  p-6  m-2 ">
      <div class="w-full">
        <div class=" flex">
          <span
            class="w-1/3 font-semibold text-gray-700 border-2 border-gray-600 p-2 !border-r-0 !border-b-0 flex items-center">Open
            Challenge Version:</span>
          <span
            class="w-2/3 text-gray-900 border-2 border-gray-600 p-2 !border-b-0 flex items-center">{{responseData?.name}}</span>
        </div>
        <div class=" flex">
          <span
            class="w-1/3 font-semibold text-gray-700 border-2 border-gray-600 p-2 !border-r-0 !border-b-0 flex items-center">Start
            Date:</span>
          <span
            class="w-2/3 text-gray-900 border-2 border-gray-600 p-2 !border-b-0 flex items-center">{{responseData?.start_date
            | date:'dd-MM-yyyy'}}</span>
        </div>
        <div class=" flex">
          <span
            class="w-1/3 font-semibold text-gray-700 border-2 border-gray-600 p-2 !border-r-0 !border-b-0 flex items-center">End
            Date:</span>
          <span
            class="w-2/3 text-gray-900 border-2 border-gray-600 p-2 !border-b-0 flex items-center">{{responseData?.end_date
            | date:'dd-MM-yyyy'}}</span>
        </div>
        <div class=" flex">
          <span
            class="w-1/3 font-semibold text-gray-700 border-2 border-gray-600 p-2 !border-r-0 !border-b-0 flex items-center">Scheme:</span>
          <span class="w-2/3 text-gray-900 border-2 border-gray-600 !border-b-0 flex items-center p-2">Open
            Challenge</span>
        </div>
        <div class=" flex">
          <span
            class="w-1/3 font-semibold text-gray-700 border-2 border-gray-600 p-2 !border-r-0  flex items-center">Forwarded
            to (directorates):</span>
          <span
            class="w-2/3 text-gray-900 flex flex-wrap gap-2 border-2 border-gray-600 p-2  min-h-[2.5rem] items-center py-1">
            <span class="bg-blue-100 text-blue-800 px-2 py-1 rounded text-xs"
              *ngFor="let nd of responseData?.nodal_directorates">{{ nd.name }}</span>
          </span>
        </div>
        <!-- INSERT_YOUR_CODE -->

      </div>
    </div>
  </div>
  <div *ngIf="stepDetails == 'screening'"
    class="bg-amber-50 border-2 border-gray-300 mb-6 transition-all duration-200 hover:shadow-md mx-2">
    <div
      class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200"
      (click)="showNilRemarks = !showNilRemarks" tabindex="0" style="outline: none;"
      (keydown.enter)="showNilRemarks = !showNilRemarks" role="button">
      <h3 class="text-lg font-semibold flex items-center select-none">
        <span class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm">
          <i class="pi pi-file"></i>
        </span>
        Nil Return Remarks

      </h3>
      <span class="ml-4 text-xs text-blue-600 flex items-center">
        <i [ngClass]="showNilRemarks ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></i>
      </span>
      <!-- Optionally, additional icons or action buttons may be placed here-->
    </div>
    <div *ngIf="showNilRemarks" class="transition-all duration-200 animate-fade-in">
      <div class="mb-3 flex w-full">
        <span class="w-full text-gray-900 flex flex-col min-h-[2.5rem]">
          <ng-container *ngIf="responseData?.nil_returns?.length > 0;">
            <ng-container *ngFor="let remarkObj of responseData.nil_returns">
              <div class="bg-gray-50 border-l-2 border-b-2 border-r-2 border-gray-600 p-0 flex">
                <!-- User info: 1/3 -->
                <div class="w-1/3 flex flex-col items-start justify-center px-3 py-2 border-r-2 border-gray-600"
                  style="min-width:180px;">
                  <span class="font-semibold text-gray-700 block">
                    Nil Return by <span class="text-blue-500"> {{ remarkObj.user.unit.name }}</span>
                  </span>
                </div>
                <!-- Remark: 2/3 -->
                <div class="w-2/3 flex flex-col justify-center px-3 py-2">
                  <div class="text-gray-700 whitespace-pre-line" *ngIf="remarkObj.remark; else noRemarkText">
                    {{ remarkObj.remark }}
                  </div>
                  <ng-template #noRemarkText>
                    <span class="text-gray-400 italic">No remark provided.</span>
                  </ng-template>
                </div>
              </div>
            </ng-container>
          </ng-container>
        </span>
      </div>
    </div>
  </div>
  <div *ngIf="stepDetails == 'screening'"
    class="bg-amber-50 border-2 border-gray-300 mb-6 transition-all duration-200 hover:shadow-md mx-2">
    <div
      class="flex items-center justify-between p-2 cursor-pointer bg-gray-100/90 text-gray-700 hover:bg-blue-950 hover:text-white transition-all duration-200">
      <h3 class="text-lg font-semibold flex items-center">
        <span class="w-8 h-8 rounded-lg bg-green-100 text-green-600 flex items-center justify-center mr-3 text-sm"><i
            class="pi pi-paperclip"></i></span>
        Open Challenge Proposals
      </h3>
      <div class="flex gap-2 items-center">
        <button type="button"
          class="border-2 border-blue-400 bg-blue-100 text-blue-700 font-bold px-3 py-1 rounded shadow-none hover:border-blue-600 hover:bg-blue-200"
          title="Nill" (click)="showSampleDialog=true">
          <i class="pi pi-eye-slash mr-1"></i> Hide columns
        </button>
        <button type="button"
          class="border-2 border-yellow-400 bg-yellow-100 text-yellow-700 font-bold px-3 py-1 rounded shadow-none hover:border-yellow-600 hover:bg-yellow-200"
          title="Nill" (click)="openAcceptRejectPopup('Nill')">
          <i class="pi pi-circle-off mr-1"></i> Send Nil Returns
        </button>
        <button type="button" [disabled]="selectedProposals.length === 0"
          [ngClass]="{'opacity-50 cursor-not-allowed': selectedProposals.length === 0}"
          class="border-2 border-green-400 bg-green-100 text-green-700 font-bold px-3 py-1 rounded shadow-none hover:border-green-600 hover:bg-green-200"
          title="Recommend" (click)="openAcceptRejectPopup('Recommended')">
          <i class="pi pi-thumbs-up mr-1"></i> Recommend
        </button>
        <button type="button" [disabled]="selectedProposals.length === 0"
          [ngClass]="{'opacity-50 cursor-not-allowed': selectedProposals.length === 0}"
          class="border-2 border-red-400 bg-red-100 text-red-700 font-bold px-3 py-1 rounded shadow-none hover:border-red-600 hover:bg-red-200"
          title="Reject" (click)="openAcceptRejectPopup('Rejected')">
          <i class="pi pi-times mr-1"></i> Reject
        </button>
      </div>

    </div>
    <div class="p-2 space-y-4 border-t border-slate-100 animate-fade-in">

      <p-table #dt [value]="tableData" [paginator]="tableData.length > 10" [rows]="10" [showCurrentPageReport]="true"
        selectionMode="multiple" [scrollable]="true" [(selection)]="selectedProposals" [resizableColumns]="true"
        [reorderableColumns]="true" dataKey="id" class="min-w-full text-sm">
        <ng-template pTemplate="header">
          <tr>
            <th class="w-10 bg-blue-100 border-b border-blue-200"></th>
            <ng-container *ngFor="let column of filterColoum">
              <th [pSortableColumn]="column.field" pResizableColumn>
                <div class="flex items-center justify-between">
                  <span>{{ column.header }}</span>
                  <i class="fa-solid fa-signal fa-rotate-270 ml-4 text-xs"></i>
                </div>
              </th>
            </ng-container>
            <th pFrozenColumn alignFrozen="right"
              class="px-4 py-2 bg-blue-100 text-blue-900 font-semibold border-b border-blue-200 whitespace-nowrap">
              Actions
            </th>
            <!-- <th pFrozenColumn class="px-4 py-2 bg-blue-100 text-blue-900 font-semibold border-b border-blue-200 whitespace-nowrap">Actions</th> -->
          </tr>
          <tr>
            <th></th>
            <th *ngFor="let column of filterColoum">
              <input *ngIf="column.filterType" type="text" [(ngModel)]="column.filterValue"
                (input)="dt.filter(column.filterValue, column.field, 'contains')" [attr.placeholder]=" column.header"
                class="w-full px-2 py-1 border-blue-200 rounded font-medium text-gray-600 text-xs" />
            </th>
            <th pFrozenColumn alignFrozen="right"></th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-proposal>
          <tr class="hover:bg-blue-50 transition-colors duration-200">
            <td class="align-middle px-2 py-2 border-b border-gray-100">
              <p-tableCheckbox [disabled]="proposal.status === 'Recommended' || proposal.status === 'Rejected'"
                [value]="proposal"></p-tableCheckbox>
            </td>
            <ng-container *ngFor="let column of filterColoum">
              <td class="align-middle px-4 py-2 border-b border-gray-100 whitespace-nowrap">
                <ng-container [ngSwitch]="column.vType">
                  <ng-container *ngSwitchCase="'status'">
                    <span [ngClass]="getStatusClass(proposal[column.field])"
                      class="inline-flex items-center px-3 py-1 rounded-full text-xs border-2 font-bold ">{{
                      proposal[column.field] }}</span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'dropdown'">
                    <span class="whitespace-pre-wrap min-w-[120px]">{{ proposal[column.field] || '-' }}</span>
                  </ng-container>
                  <ng-container *ngSwitchCase="'supporting_doc'">
                    <button
                      class="border-2 border-yellow-400 bg-yellow-100 text-yellow-700 font-bold px-2 py-1 rounded shadow-none mr-2 text-base hover:border-yellow-500 hover:bg-yellow-200 transition-colors outline-none focus:outline-none"
                      (click)="downloadProposal(proposal)" title="Download">
                      <i class="pi pi-download"></i>
                    </button>
                  </ng-container>
                  <ng-container *ngSwitchDefault>
                    <span class="whitespace-pre-wrap min-w-[200px]">{{ proposal[column.field] || '-' }}</span>
                  </ng-container>
                </ng-container>
              </td>
            </ng-container>
            <td pFrozenColumn alignFrozen="right"
              class="align-middle px-4 py-2 border-b border-gray-100 whitespace-nowrap">
              <button
                class="border-2 border-purple-400 bg-purple-100 text-purple-700 font-bold px-2 py-1 rounded shadow-none mr-2 text-base hover:border-purple-500 hover:bg-purple-200 transition-colors outline-none focus:outline-none"
                (click)="openPopup(proposal)" title="View">
                <i class="pi pi-eye"></i>
              </button>

              <button *ngIf="role_id ==='19'"
                class="border-2 border-red-400 bg-red-100 text-red-700 font-bold px-2 py-1 rounded shadow-none text-base hover:border-red-500 hover:bg-red-200 transition-colors outline-none focus:outline-none"
                (click)="deleteProposal(proposal)" title="Delete">
                <i class="pi pi-trash"></i>
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="tableColumns.length + 2" class="text-center py-8 text-gray-400"><i
                class="pi pi-info-circle mr-2"></i> No proposals found.</td>
          </tr>
        </ng-template>
      </p-table>

    </div>
  </div>
</div>
<p-toast></p-toast>


<ng-container *ngIf="displayUploadDialog">
  <p-dialog header="Uploaded Proposal Document" [(visible)]="displayUploadDialog" [modal]="true"
    [style]="{ width: '70vw' }">
    <app-step-details [applicantData]="applicantData" [versionData]="responseData"></app-step-details>

  </p-dialog>
</ng-container>


<p-toast position="center" key="confirm" [baseZIndex]="5000">
  <ng-template let-message pTemplate="message">
    <div class="toast-body d-flex flex-column align-items-center p-2">
      <div class="fw-medium fs-6 text-dark mb-2 d-flex align-items-center justify-content-center">
        <i class="pi pi-question-circle text-2xl text-blue-600 me-2"></i>
        <span class="text-lg font-semibold">
          Confirmation Required
        </span>
      </div>
      <div class="text-center mb-3">
        Are you sure you want to submit this proposal?<br>
        Once submitted, you may not be able to make further changes.
      </div>
      <div class="d-flex justify-content-center gap-2 mt-2">
        <button type="button" class="btn btn-outline-secondary" style="min-width: 90px" (click)="clear()">
          <i class="pi pi-times"></i> Cancel
        </button>
        <button type="button" class="btn btn-primary" style="min-width: 90px" (click)="finalSubmit()">
          <i class="pi pi-check"></i> Yes, Submit
        </button>
      </div>
    </div>
  </ng-template>
</p-toast>


<!-- CONFIRM POPUP -->
<div *ngIf="showConfirm"
  class="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-2 sm:p-4">

  <!-- MODAL -->
  <div
    class="bg-white w-full sm:max-w-2xl lg:max-w-4xl rounded-lg shadow-2xl border border-gray-200 flex flex-col max-h-[90vh]">

    <!-- HEADER (FIXED) -->
    <div class="px-4 py-2.5 bg-gray-50 border-b flex justify-between items-center shrink-0">
      <h3 class="font-bold text-gray-700 text-base mb-0">
        {{actionType === 'Recommended' ? 'Route Configuration' :
        actionType === 'Nill' ? 'Send Nil Returns' :
        actionType === 'Rejected' ? 'Rejection Reason' : 'Confirmation'}}
      </h3>
      <button (click)="showConfirm = false" class="text-gray-400 hover:text-gray-600">
        <i class="pi pi-times"></i>
      </button>
    </div>

    <!-- BODY (SCROLLABLE) -->
    <div class="px-4 py-3 overflow-y-auto scroll-smooth">

      <!-- RECOMMENDED SECTION -->
      <div *ngIf="actionType === 'Recommended'" class="space-y-3">

        <!-- Share Mode -->
        <div
          class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 bg-blue-50/50 p-2 rounded-md border border-blue-100">
          <span class="text-sm font-semibold text-blue-800">Share Mode:</span>

          <div class="flex gap-4">
            <label class="inline-flex items-center gap-2 cursor-pointer">
              <p-radioButton name="shareType" value="internal" (onChange)="onShareTypeChange('internal')"
                [(ngModel)]="shareType">
              </p-radioButton>
              <span class="text-sm font-medium">Internal</span>
            </label>

            <label class="inline-flex items-center gap-2 cursor-pointer">
              <p-radioButton name="shareType" value="external" (onChange)="onShareTypeChange('external')"
                [(ngModel)]="shareType">
              </p-radioButton>
              <span class="text-sm font-medium">External</span>
            </label>
          </div>
        </div>

        <!-- Dropdown -->
        <div>
          <label class="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">
            Send to ({{shareType}})
          </label>

          <!-- INTERNAL -->
          <p-dropdown *ngIf="shareType === 'internal'" [options]="userList" optionLabel="first_name" [filter]="true"
            class="w-full" filterBy="first_name,last_name,loginname,hrcdf_designation" [(ngModel)]="selectedUser"
            placeholder="Search and select user" appendTo="body">

            <ng-template pTemplate="item" let-user>
              <div class="py-1">
                <p class="text-sm font-semibold mb-0">
                  #{{ user.loginname }} - {{ user.first_name }} {{ user.last_name }}
                </p>
                <p class="text-xs text-gray-500 mb-0">
                  {{ user.hrcdf_designation }}
                </p>
              </div>
            </ng-template>
          </p-dropdown>

          <!-- EXTERNAL -->
          <p-dropdown *ngIf="shareType === 'external'" [options]="nodalDirectorates" optionLabel="name" optionValue="id"
            class="w-full" [(ngModel)]="selectedUnit" placeholder="Choose a directorate" appendTo="body">
          </p-dropdown>
        </div>

        <!-- Editor -->
        <!-- <div>
          <label class="block text-xs font-bold text-gray-500 uppercase tracking-wider mb-1">
            Brief Proposal
          </label>
          <div class="border rounded-md overflow-hidden">
            <editor [init]="init" [(ngModel)]="brief"></editor>
          </div>
        </div> -->

      </div>

      <!-- REMARK / REJECTION -->
      <div *ngIf="actionType === 'Rejected' || actionType === 'Nill' || actionType === 'Recommended'"
        class="space-y-2 mt-3">
        <label class="block text-sm font-semibold"
          [ngClass]="actionType === 'Rejected' ? 'text-red-600' : 'text-blue-600'">

          {{ actionType === 'Rejected' ? 'Reason for Rejection:' : 'Remark:' }}
        </label>

        <textarea
          class="w-full border border-gray-300 rounded-md p-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
          rows="4" [(ngModel)]="reasonForReject"
          [placeholder]="actionType === 'Rejected' ? 'Type the rejection cause here...' : 'Enter your remarks...'">
        </textarea>
      </div>

    </div>

    <!-- FOOTER (FIXED) -->
    <div class="px-4 py-3 bg-gray-50 border-t flex flex-col sm:flex-row justify-end gap-2 shrink-0">

      <button
        class="px-4 py-1.5 text-sm font-medium text-gray-600 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
        (click)="showConfirm = false">
        Cancel
      </button>

      <button class="px-4 py-1.5 text-sm font-medium text-white rounded-md shadow-sm"
        [ngClass]="actionType === 'Rejected' ? 'bg-red-600 hover:bg-red-700' : 'bg-green-600 hover:bg-green-700'"
        (click)="acceptSelectedProposals(actionType)">
        Confirm Action
      </button>

    </div>

  </div>
</div>

<div *ngIf="stepDetails == 'approval'">
  <div *ngIf="currentStep.code == 'SCR-APP' && currentStep?.can_edit" class="m-4 flex items-center justify-between">
    <label for="categoryDropdown" class="block  font-bold text-gray-700 mb-2 w-1/4">Category</label>
    <div class="w-3/4">
      <p-dropdown id="categoryDropdown" [options]="categoryList" optionLabel="name" optionValue="value"
        placeholder="Choose a category" [(ngModel)]="selectedCategory" styleClass="w-full" appendTo="body">
      </p-dropdown>

    </div>
  </div>
  <div *ngIf="currentStep.code == 'S-C' && currentStep?.can_edit" class="m-4 flex items-center justify-between">
    <label for="categoryDropdown" class="block  font-bold text-gray-700 mb-2 w-1/4">Change status</label>
    <div class="w-3/4">
      <p-dropdown id="statusDropdown"
        [options]="[{label: 'Accept', value: 'Accept'}, {label: 'Duplicate', value: 'Duplicate'}, {label: 'Reject', value: 'Reject'}]"
        optionLabel="label" placeholder="Choose a status" optionValue="value" [(ngModel)]="selectedCategory"
        styleClass="w-full" appendTo="body">
      </p-dropdown>

    </div>
  </div>
  <app-step-details [applicantData]="applicantData" [versionData]="responseData"></app-step-details>
</div>

<p-dialog header="Hide/Show Columns" [(visible)]="showSampleDialog" [modal]="true" [closable]="true"
  [dismissableMask]="true" [style]="{width: '750px'}">
  <div class="p-2 bg-white">
    <!-- INSERT_YOUR_CODE -->
    <!-- <label class="font-semibold mb-2 block">Hide/Show Columns:</label> -->
    <div class="grid grid-cols-3  gap-2">
      <ng-container *ngFor="let column of tableColumns">
        <div class="flex items-center border">
          <input type="checkbox" [(ngModel)]="column.visible" (ngModelChange)="syncVisibleColumns()"
            id="{{'column-toggle-' + column.field}}" class="mr-2 p-2 h-10" />
          <label [for]="'column-toggle-' + column.field">{{ column.header }}</label>
        </div>
      </ng-container>
    </div>
  </div>
</p-dialog>

<!-- INSERT_YOUR_CODE -->
<p-dialog header="Confirm Deletion" [(visible)]="showDeleteConfirmDialog" [modal]="true" [closable]="false"
  [dismissableMask]="true" [style]="{width: '350px'}">
  <div class="p-6 flex flex-col items-center text-center">
    <i class="pi pi-exclamation-triangle text-yellow-500 text-4xl mb-2"></i>
    <h3 class="font-bold text-lg mb-1">Delete Record?</h3>
    <p class="text-gray-600 mb-4">Are you sure you want to delete this record? This action cannot be undone.</p>
    <div class="flex justify-center gap-4 mt-2">
      <button class="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600 transition" type="button"
        (click)="confirmDelete()">
        Yes, Delete
      </button>
      <button class="px-4 py-2 rounded bg-gray-200 text-gray-700 hover:bg-gray-300 transition" type="button"
        (click)="showDeleteConfirmDialog=false">
        Cancel
      </button>
    </div>
  </div>
</p-dialog>